import { SET_DATA } from 'helpers/Constants';
import React, { createContext, useReducer } from 'react';
import reducer from 'reducers/reducer';

export const Context = createContext();

export const Provider = ({ children, ...initialState }) => {
  const [state, dispatch] = useReducer(reducer, initialState || {});

  const store = {
    ...state,
    setData: (data) => dispatch({ type: SET_DATA, payload: data })
  };

  return <Context.Provider value={store}>{children}</Context.Provider>;
};
